module.exports = __webpack_public_path__ + "img/min_desarrollo.46f5af9c.jpeg";